<template>
  <egg-label-list
    title="telemedicine.howItWorks"
    titleColor="#7BA7D8"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconLightBlue', imgFormat: 'svg' }"
    :eggBackgroundObj="{ componentName: 'shared', imgName: 'lightblueegg', imgFormat: 'svg' }"
    labelColor="#4E4E4E"
    :eggIconLabelList="telemedicineStore.eggDescList"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useTelemedicineStore } from "@/stores/telemedicine";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const telemedicineStore = useTelemedicineStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>